import { render, staticRenderFns } from "./FormElementText.vue?vue&type=template&id=3c2ed3b9&scoped=true&"
import script from "./FormElementText.vue?vue&type=script&lang=js&"
export * from "./FormElementText.vue?vue&type=script&lang=js&"
import style0 from "./FormElementText.vue?vue&type=style&index=0&id=3c2ed3b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2ed3b9",
  null
  
)

export default component.exports